import {EventEmitter, Injectable} from '@angular/core';
import {Topbar} from "../model/topbar";
import {AppService} from "./app.service";

@Injectable()
export class SharedService {

  public headerUpdated: EventEmitter<Topbar[]> = new EventEmitter<Topbar[]>();

  constructor(private appService: AppService) { }

  updateHeader(user_id: number, key: string) {
    this.appService.getHeader(user_id, key).subscribe((headerList) => {
      localStorage.setItem('headerList', JSON.stringify(headerList));
      this.headerUpdated.emit(headerList);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts